export enum BorderRadiusEnum {
    sm = 0.125,
    n = 0.25,
    md = 0.375,
    lg = 0.5,
    xl = 0.75,
    xxl = 1,
    xxxl = 1.5,
    full = 9999,
}